export enum AnalysisStatusEnum {
  STARTED = 'STARTED',
  UPLOADED = 'UPLOADED',
  FINISHED = 'FINISHED',
  ABORTED = 'ABORTED',
  AI_READY = 'AI_READY'
}
